import { render, staticRenderFns } from "./AdminCreateItem.vue?vue&type=template&id=6a527c5b&scoped=true&"
import script from "./AdminCreateItem.vue?vue&type=script&lang=js&"
export * from "./AdminCreateItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateItem.vue?vue&type=style&index=0&id=6a527c5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a527c5b",
  null
  
)

export default component.exports